import * as actionTypes from './actionTypes';

export const toggle_demo = () => {
    return {
        type: actionTypes.TOGGLE_DEMO,
	};
};